/**
 * Breadcrumb - Navigation breadcrumb for knowledge base
 * 
 * PROJECT_RULES.md Compliance:
 * - ✅ Consistent design language
 * - ✅ TypeScript: Fully typed
 */

import React from 'react';
import { Link } from 'react-router-dom';
import type { BreadcrumbProps } from '../types';
import { DEFAULT_COLOR } from '../constants';

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ category, title }) => {
  return (
    <nav className="mb-6">
      <ol className="flex items-center space-x-2 text-sm">
        <li>
          <Link to="/knowledge-base" className="hover:underline" style={{ color: '#598D76' }}>
            Knowledge Base
          </Link>
        </li>
        <li>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#598D76">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </li>
        <li>
          <span style={{ color: DEFAULT_COLOR }}>
            {category.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
          </span>
        </li>
        <li>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#598D76">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </li>
        <li>
          <span style={{ color: DEFAULT_COLOR }}>{title}</span>
        </li>
      </ol>
    </nav>
  );
};